import * as am5 from "@amcharts/amcharts5";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import * as am5xy from "@amcharts/amcharts5/xy";
import React, { useEffect, useLayoutEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RightUpIcon } from "../../../../../assets/icons/svgicons";
import {
  getDashboardGraphDataAction,
  getPortfolioAction,
} from "../../../../../features/user/userSlice";
import { formatPrice, chartTooltip } from "../../../../../utils/utils";
import Card from "../../../../common/Card/Card";
import Select from "../../../../common/Formik/Select/Select";
import styles from "./AssetsValue.module.scss";

const AssetsValue = () => {
  const dispatch = useDispatch();
  const [valuesForGraph, setValuesForGraph] = useState([{}]);
  const spotPrice = useSelector((state) => state?.users?.spotPrice);
  const [priceChange, setPriceChange] = useState();
  const [percentageChange, setPercentageChange] = useState();
  const [portfolioBalance, setPortfolioBalance] = useState();
  const [goldData, setGoldData] = useState();
  const [silverData, setSilverData] = useState();
  const [equityData,setEquityData] = useState();
  const kycStatus = useSelector(
    (state) => state?.persist?.userInfo?.kyc_status
  );
  const equityPrice = useSelector((state) => state?.users?.equityPrice);

  const timeOptions = [
    {
      label: "Weekly",
      value: "WEEK",
      timeUnit: "day",
      count: 1,
    },
    {
      label: "Today",
      value: "DAY",
      timeUnit: "hour",
      count: 2,
    },
    // {
    //   label: "Monthly",
    //   value: "MONTH",
    //   timeUnit: "month",
    //   count: 1,
    // },
    // {
    //   label: "Yearly",
    //   value: "YEAR",
    //   timeUnit: "year",
    //   count: 1,
    // },
  ];

  const [filter, setFilter] = useState(timeOptions[0]);

  // var data = [
  //   {
  //     date: new Date(2021, 0, 1).getTime(),
  //     value: 1,
  //     value2: 2.5,
  //   },
  //   {
  //     date: new Date(2022, 0, 2).getTime(),
  //     value: 3,
  //     value2: 2.1,
  //   },
  //   {
  //     date: new Date(2023, 0, 3).getTime(),
  //     value: 2,
  //     value2: 3,
  //   },
  //   {
  //     date: new Date(2024, 0, 4).getTime(),
  //     value: 1,
  //     value2: 2,
  //   },
  //   {
  //     date: new Date(2025, 0, 5).getTime(),
  //     value: 1.5,
  //     value2: 0.5,
  //   },
  // ];

  const getDateFormat = (date, index) => {
    let formatDate;
    switch (filter?.value) {
      case "WEEK":
        formatDate = new Date(date?.date).getTime();
        break;
      case "YEAR":
        formatDate = new Date(date?.date, 0, index + 1).getTime();
        break;
      case "DAY":
        formatDate = new Date(date?.date).getTime();
        break;
      case "MONTH":
        formatDate = new Date(`${date?.year}-${date?.month}`).getTime();
        break;
      default:
        break;
    }

    return formatDate;
  };

  // const getGraphData = async (data) => {
  //   try {
  //     const params = {
  //       dateFilterVal: filter?.value,
  //       // filterByToken: "",
  //     };
  //     const response = await dispatch(getDashboardGraphDataAction(params));
  //     // to get Portfolio balance
  //     const res = await dispatch(getPortfolioAction(params));

  //     if (res.status === 200) {
  //       setPortfolioBalance(res?.data?.data);
  //     }

  //     if (response.status === 200) {
  //       const array = [];
  //       // console.log(response?.data?.data);
  //       response?.data?.data?.map((item, index) => {
  //         let formDate = getDateFormat(item, index);
  //         array.push({
  //           date: formDate,
  //           value: Number(item?.value),
  //         });
  //       });

  //       setValuesForGraph(array);
  //     }
  //   } catch (error) {
  //     console.log("Error");
  //   }
  // };

  const getPortfolioData = async (data) => {
    try {
      const params = {
        dateFilterVal: filter?.value,
        // filterByToken: tokenId,
      };

      const res = await dispatch(getPortfolioAction(params));
      if (res.status === 200) {
        setGoldData(res?.data?.data?.find((item) => item.name === "Gold STBL"));
        setEquityData(res?.data?.data?.find((item) => item.name === "Equity"));

        setSilverData(
          res?.data?.data?.find((item) => item.name === "Silver STBL")
        );
      }
    } catch (error) {
      console.log("Error");
    }
  };

  const getGraphData = async (data) => {
    try {
      const params = {
        dateFilterVal: filter?.value,
        // filterByToken: tokenId,
      };

      const response = await dispatch(getDashboardGraphDataAction(params));
      if (response.status === 200) {
        const array = [];
        response?.data?.data[0]?.data?.map((item, index) => {
          let formDate = getDateFormat(item, index);
          array.push({
            date: formDate,
            value: Number(item?.value),
          });
        });

        setValuesForGraph(array);
      }
    } catch (error) {
      console.log("Error");
    }
  };
  useEffect(() => {
    const goldBalance = goldData?.tokenBalance * spotPrice.goldPrice;

    const silverBalance = silverData?.tokenBalance * spotPrice.silverPrice;
    const equityBalance = equityData?.tokenBalance * equityPrice?.price
    

    const portfolioBalance = goldBalance + silverBalance + equityBalance;
    setPortfolioBalance(portfolioBalance);

    const previousGoldValue = goldData?.tokenBalance * goldData?.price;
    const previousSilverValue = silverData?.tokenBalance * silverData?.price;
    const previousEquityBalance = equityData?.tokenBalance * equityData?.price
    const previousPortfolioValue = previousGoldValue + previousSilverValue +previousEquityBalance;

    const priceChange = portfolioBalance - previousPortfolioValue;
    setPriceChange(priceChange);

    const percentageChange = (priceChange / portfolioBalance) * 100;
    setPercentageChange(percentageChange);
  }, [spotPrice, filter]);

  useEffect(() => {
    getGraphData();
  }, [filter]);

  useEffect(() => {
    getPortfolioData();
  }, [filter]);

  useLayoutEffect(() => {
    if (valuesForGraph?.length > 0 && kycStatus === "APPROVED") {
      var root = am5.Root.new("chartdivInvestment");

      root.setThemes([am5themes_Animated.new(root)]);

      var chart = root.container.children.push(
        am5xy.XYChart.new(root, {
          panY: false,
          wheelY: "zoomX",
          layout: root.verticalLayout,
          maxTooltipDistance: 0,
        })
      );

      var yAxis = chart.yAxes.push(
        am5xy.ValueAxis.new(root, {
          extraTooltipPrecision: 1,
          renderer: am5xy.AxisRendererY.new(root, {}),
          numberFormat: "'$'#,###",
        })
      );

      // Create X-Axis
      var xAxis = chart.xAxes.push(
        am5xy.DateAxis.new(root, {
          baseInterval: { timeUnit: filter?.timeUnit, count: filter?.count },
          renderer: am5xy.AxisRendererX.new(root, {
            minGridDistance: 20,
          }),
        })
      );

      xAxis.get("renderer").grid.template.setAll({
        location: 0,
        strokeWidth: 0,
        visible: false,
      });

      // Create series
      function createSeries(name, field) {
        var series = chart.series.push(
          am5xy.SmoothedXLineSeries.new(root, {
            name: name,
            xAxis: xAxis,
            yAxis: yAxis,
            valueYField: field,
            valueXField: "date",
            stroke: "#0E61D1",
            tooltip: am5.Tooltip.new(root, {
              // labelText: "{valueX.formatDate()}: {valueY}",
              ...chartTooltip,
              centerX: am5.p50,
              x: am5.p50,
            }),
          })
        );

        series.strokes.template.set("strokeWidth", 2);

        series.bullets.push(function (root) {
          var circle = am5.Circle.new(root, {
            radius: 6,
            stroke: "#0E61D1",
            fill: "#0E61D1",
            opacity: 0,
            interactive: true,
          });

          circle.states.create("default", {
            opacity: 0,
          });

          circle.states.create("hover", {
            opacity: 1,
          });

          return am5.Bullet.new(root, {
            sprite: circle,
          });
        });
        series.data.setAll(valuesForGraph);
        series.fills.template.set(
          "fillGradient",
          am5.LinearGradient.new(root, {
            stops: [
              {
                opacity: 0.1,
              },
              {
                opacity: 0,
              },
            ],
            rotation: 90,
          })
        );
        series.fills.template.setAll({
          visible: true,
          fillOpacity: 1,
        });
      }

      createSeries("", "value");

      // Add cursor
      var cursor = chart.set(
        "cursor",
        am5xy.XYCursor.new(root, {
          behavior: "zoomXY",
          xAxis: xAxis,
        })
      );
      cursor.lineY.set("visible", false);
      cursor.lineX.set("visible", false);
      let xRenderer = xAxis.get("renderer");
      xRenderer.labels.template.setAll({
        fill: am5.color("#45576F"),
        fontSize: "1.4em",
      });

      let yRenderer = yAxis.get("renderer");
      yRenderer.labels.template.setAll({
        fill: am5.color("#45576F"),
        fontSize: "1.4em",
      });

      var previousBulletSprites = [];
      cursor.events.on("cursormoved", cursorMoved);

      function cursorMoved() {
        for (var i = 0; i < previousBulletSprites.length; i++) {
          previousBulletSprites[i].unhover();
        }
        previousBulletSprites = [];
        chart.series.each(function (series) {
          var dataItem = series.get("tooltip").dataItem;
          if (dataItem) {
            var bulletSprite = dataItem.bullets[0].get("sprite");
            bulletSprite.hover();
            previousBulletSprites.push(bulletSprite);
          }
        });
      }

      // xAxis.set(
      //   "tooltip",
      //   am5.Tooltip.new(root, {
      //     themeTags: ["axis"],
      //   })
      // );

      // yAxis.set(
      //   "tooltip",
      //   am5.Tooltip.new(root, {
      //     themeTags: ["axis"],
      //   })
      // );
      return () => {
        root.dispose();
      };
    }
  }, [valuesForGraph]);

  useEffect(() => {
    getGraphData();
  }, [filter]);

  return (
    <>
      <Card
        title="Assets Value"
        className={styles.assets_balance}
        headerContent={
          <>
            <Select
              className={styles.select_time}
              options={timeOptions}
              formatOptionLabel={(option) => <h5>{option.label}</h5>}
              placeholder={<h5>Weekly</h5>}
              isSearchable={false}
              onChange={(selected) => setFilter(selected)}
              defaultValue={timeOptions[0]}
            />
          </>
        }
      >
        <div className={styles.graph_content}>
          <div className={styles.graph_data}>
            <div>
              <p>Portfolio value</p>
              <h2 className={`${styles.price_text} not_responsive`}>
                ${formatPrice(Number(portfolioBalance))}
              </h2>
              <h5
                className={`${
                  portfolioBalance <= 0 ? styles.loss : styles.profit
                } ${styles.value_text}`}
              >
                <RightUpIcon />${formatPrice(Number(priceChange))} (
                {formatPrice(Number(percentageChange))}%)
              </h5>
            </div>
            <div>
              <p className={styles.total_invested}>Total Invested</p>
              <h4 className={`${styles.price_text}`}>
                {" "}
                ${formatPrice(Number(portfolioBalance))}
              </h4>
            </div>
          </div>
          <div
            id="chartdivInvestment"
            style={{ width: "100%", height: "200px" }}
          ></div>
          {/* <img src={AssetsGraph} alt="sample-graph" className="mt-" /> */}
        </div>
      </Card>
    </>
  );
};

export default AssetsValue;
